import {Component,type ErrorInfo,type ReactNode} from 'react'
export class PageRecovery extends Component<{children:ReactNode;onReload?:()=>void},{failed:boolean}> {
  state={failed:false}
  static getDerivedStateFromError(){return {failed:true}}
  componentDidCatch(error:Error,info:ErrorInfo){console.error('诗序页面打开失败',error,info.componentStack)}
  render(){
    if(!this.state.failed)return this.props.children
    return <main className="splash-screen" role="alert"><span>诗</span><h1>页面暂时无法打开</h1><p>应用更新或网络中断可能使页面加载失败。请重新打开，已保存的账号和云端记录会保留。</p><button className="primary-button" style={{maxWidth:260}} onClick={this.props.onReload??(()=>window.location.reload())}>重新打开诗序</button></main>
  }
}
